(function () {
  const skuDisplay = document.getElementById('hersteller-sku-display');
  const barcodeDisplay = document.getElementById('barcode-display');

  if (!skuDisplay) return;

  // Daten aus data-Attribut lesen
  const productFallback = skuDisplay.dataset.productFallback || '';
  let variants = {};
  try {
    const arr = JSON.parse(skuDisplay.dataset.variants || '[]');
    arr.forEach(function(v) { variants[v.id] = v; });
  } catch(e) {
    console.error('Fehler beim Parsen der Varianten-Daten:', e);
    return;
  }

  console.log('Varianten geladen:', variants);

  function updateVariantData(variantId) {
    const id = parseInt(variantId, 10);
    const data = variants[id];
    console.log('Update für ID:', id, 'Daten:', data);

    if (skuDisplay) {
      const sku = (data && data.sku) ? data.sku : productFallback;
      if (sku) {
        skuDisplay.innerHTML = '<strong>Herstellernummer:          </strong> ' + sku;
        skuDisplay.style.display = '';
      } else {
        skuDisplay.style.display = 'none';
      }
    }

    if (barcodeDisplay) {
      const barcode = (data && data.barcode) ? data.barcode : '';
      if (barcode) {
        barcodeDisplay.innerHTML = '<strong>EAN:          </strong> ' + barcode;
        barcodeDisplay.style.display = '';
      } else {
        barcodeDisplay.style.display = 'none';
      }
    }
  }

  function attachObserver() {
    const input = document.querySelector('form[action*="/cart/add"] input[name="id"]');
    if (input) {
      const initialValue = input.getAttribute('value') || input.value;
      input._value = initialValue;
      updateVariantData(initialValue);

      Object.defineProperty(input, 'value', {
        get: function () { return this._value; },
        set: function (v) {
          this._value = String(v);
          updateVariantData(this._value);
        },
        configurable: true
      });
    } else {
      setTimeout(attachObserver, 500);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attachObserver);
  } else {
    attachObserver();
  }
})();
